import * as React from "react";
import { Link } from "react-router-dom";
import Feedback from "../views/Feedback";

const footerData = [
  {
    text: "Terms of Service",
    url: "/terms-of-service",
  },
  {
    text: "Privacy Policy",
    url: "/privacy-policy",
  },
];

function Footer({ dockSlot }) {
  return (
    <footer className="bg-white w-full">
      <div
        className="bg-white w-full px-[28px] md:pl-[300px] py-[10px] relative"
        style={dockSlot ? { paddingRight: 76 } : undefined}
      >
        <div className="flex flex-row items-center justify-between gap-6">
          <p className="text-[#767676] m-0 text-[12px] font-ubuntu pl-[12px]">
            © The BI Collaborative. All rights reserved.
          </p>
          {!process.env.REACT_APP_HIDE_LOGO && (
            <img
              className="object-contain w-[55px]"
              src={`${process.env.REACT_APP_SHARED_IMAGES_URL}/prism-logo.png`}
              alt="The BI Collaborative Logo"
            />
          )}
          <nav className="flex items-center gap-6 text-[12px] text-[#767676] md:text-[13px]">
            <Feedback inline />
            {footerData.map((link, index) => (
              <Link
                key={index}
                to={link.url}
                className="text-[#767676] hover:text-[#f88109] transition-colors"
              >
                {link.text}
              </Link>
            ))}
          </nav>
        </div>
        {dockSlot && (
          <div
            style={{
              position: "absolute",
              right: 8,
              top: "35%",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "auto",
            }}
          >
            {dockSlot}
          </div>
        )}
      </div>
    </footer>
  );
}

export default Footer;
